export const GlitchText = ({ text, className = '' }) => {
  return (
    <span
      className={`glitch ${className}`}
      data-text={text}
      data-testid="glitch-text"
    >
      {text}
    </span>
  );
};
